/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
document.querySelectorAll('.preset-colors').forEach((color_preset) => {
  colorPickerActivate(color_preset);
});
function colorPickerActivate (color_preset) {
  if (color_preset.dataset.proccessed === 'true') {
    return;
  }
  color_preset.dataset.proccessed = 'true';
  let product_selection = color_preset.parentElement;
  let product_item = product_selection.parentElement;
  let product_id = product_item.dataset.product_id;
  let product_data = document.querySelector('.product_' + product_id);

  product_selection.querySelectorAll(".color_picker").forEach((picker) => {
    const presetColors = picker.nextElementSibling;
    let isVisible = false;

    picker.addEventListener("click", function() {
      isVisible = !isVisible;
      presetColors.style.display = isVisible ? "block" : "none";
    });
  });

  for (let color_el of color_preset.children) {
    color_el.addEventListener('click', function(event) {
      event.preventDefault();
      let color_name = color_el.dataset.color;
      let pseudo_data = JSON.parse(product_data.dataset['pseudo_product__' + color_name]);

      let prev_active = color_preset.querySelector('.color--current');
      if (prev_active) {
        prev_active.classList.remove('color--current');
      }

      color_el.classList.add('color--current');

      /* Change image */
      let figure_el = product_item.querySelector('.product_card__image_block a figure');

      if (pseudo_data.image_url) {
        let image_el = figure_el.querySelector('img');
        if (!image_el) {
          image_el = document.createElement('IMG');
          figure_el.append(image_el)
        }

        image_el.src = pseudo_data.image_url;
      }

      /* Change color */
      product_item.dataset.color = color_name;

      /* Change url */
      let link_el = product_item.querySelector('.product_card__image_block a');
      let link_url = new URL(link_el.href);
      link_url.searchParams.set('co', color_name);
      link_el.href = link_url;

      /* Change id */
      product_item.dataset.variation_id = pseudo_data.variation_id;

      /* Change sizes */
      let sizes_container = product_item.querySelector('.size-container');
      let size_el = sizes_container.children[0].cloneNode(true);

      sizes_container.innerHTML = '';
      sizes_container.append(size_el);

      let first_variation = {};
      for (let key in pseudo_data.variations) {
        if (Object.keys(first_variation).length === 0) {
          first_variation = pseudo_data.variations[key];
        }
        if (key === "UNI") {continue;}
        let new_size_el = size_el.cloneNode(true);
        new_size_el.classList.remove('template');
        new_size_el.querySelector('p').textContent = key;
        new_size_el.dataset.variation_id = pseudo_data.variations[key].variation_id;
        sizes_container.append(new_size_el);
      }

      /* Change title */
      let product_name_el = product_item.querySelector('.product_card__name');
      let title = product_data.dataset.product_name;

      if (pseudo_data.title) {
        title = pseudo_data.title;
      }
      product_name_el.textContent = title;

      /* Change price */
      let product_price = product_item.querySelector('.product_card__price_span');
      if (first_variation.hasOwnProperty('display_price')) {
        product_price.textContent = first_variation.display_price;
      }
    });
  }
};

/**
 * Infinite product scroll logic
 */
document.addEventListener('DOMContentLoaded', function () {
  let page = 1;
  let loading = false; // Flag to prevent multiple requests
  const products_container = document.querySelector('.wp-block-create-block-dj-products-list');
  if (!products_container) {
    return;
  }

  const api_url = products_container.dataset.ajax_url;

  const category_id = products_container.dataset.category_id;

  // Check if the page has a "Load More" button or any trigger to load more content
  const load_more_button = document.getElementById('load-more-container').querySelector('button');
  if (load_more_button) {
      load_more_button.addEventListener('click', function() {
          loadMoreProducts();
      });
  }

  // Scroll-based infinite scroll
  window.addEventListener('scroll', function() {
      if (loading) return;

      const scroll_position = window.scrollY + window.innerHeight;
      const button_position = load_more_button.offsetTop;

      if (scroll_position >= button_position - (window.innerHeight * 2 + 400)) {
          loadMoreProducts();
      }
  });

  function loadMoreProducts() {
    loading = true; // Prevent multiple requests while loading

    const query_params = new URLSearchParams(window.location.search);
    const data_body = {};

    // Loop through all query parameters and add them to an object
    query_params.forEach((value, key) => {
      data_body[key] = value;
    });

    data_body['action'] = 'load_more_products';
    data_body['page'] = ++page;
    data_body['apg_nonce'] = apg_infinite_scroll.apg_nonce;
    data_body['category_id'] = category_id;

    fetch(api_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-WP-Nonce': apg_infinite_scroll.nonce
      },
      body: JSON.stringify(data_body),
      credentials: 'include',
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        products_container.insertAdjacentHTML('beforeend', data.content);

        document.querySelectorAll('.preset-colors').forEach((color_preset) => {
          colorPickerActivate(color_preset);
        });

        loading = false; // Allow new requests after loading is complete

        // If no more products, hide the "Load More" button or stop the scroll
        if (!data.has_more) {
          load_more_button.style.display = 'none'; // Hide button or do other actions
          loading = true;
        }
      } else {
        console.error('Failed to load more products:', data.message);
      }
    })
    .catch(error => {
      console.error('Error loading products:', error);
      loading = false; // Reset the loading flag in case of error
    });
  }
});
